<scitis-app-global-page-header [pageTitle]="'Machinery group administration'">

  <ng-template #entryCount>
    <div class="page-header-counts">
      <div class="count">
        <span class="badge badge-pill badge-primary" [innerText]="machineryGroupCount"></span>
        <span class="count-label" translate>Machinery Groups</span>
      </div>
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div class="search">
      <input class="form-control" type="search"
             [(ngModel)]="searchTerm" (change)="onSearch($event)"
             [placeholder]=" ('Search  machinery group' | translate) + '...'">
    </div>
  </ng-template>
  <ng-template #filterElement>
    <button class="btn btn-primary"
            (click)="onAddMachineGroup()"
            [disabled]="!isAdminOrHigher && !isDistributorRole">
      <span class="fa-solid fa-plus"></span>
      <span translate>New machinery group</span>
    </button>
  </ng-template>
</scitis-app-global-page-header>


<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
        <tr>

          <th scope="col" class="sortable" sortable="name" (sort)="onColumnSort($event)">
            <span translate>Name</span>
          </th>
          <th scope="col" class="sortable" sortable="parentName" (sort)="onColumnSort($event)">
            <span translate>Parent</span>
          </th>

          <th scope="col" class="text-right" style="width: 120px;">
            <span translate>Action</span>
          </th>
        </tr>
        </thead>
        <tbody>

        <tr
          *ngFor="let machinegroup of machinegroupList | paginate: paginateSettings">

          <td>
            <ngb-highlight [result]="machinegroup.name" [term]="searchTerm" [title]="machinegroup.name"
                           class="font-weight-bold truncate truncate-xxl"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="machinegroup.parentName" [title]="machinegroup.parentName"
                           class="truncate truncate-xxl" [term]="searchTerm"></ngb-highlight>
          </td>
          <td class="text-right" style="width: 120px;">
            <scitis-admin-machine-group-action [machinegroup]="machinegroup"
                                               [searchTerm]="searchTerm"
                                               [rootMachinegroupId]="rootMachinegroupId"
                                               [isAdminOrHigher]="isAdminOrHigher"
                                               [isSuperAdminRole]="isSuperAdminRole"
                                               [isDistributorRole]="isDistributorRole"
                                               [loggedUser]="loggedUser"
                                               (machinegroupDeleteEvent)="onDeleteMachinegroupSuccess(machinegroup)">
            </scitis-admin-machine-group-action>
          </td>
        </tr>
        </tbody>
      </table>
      <div *ngIf="machinegroupList.length === 0"
           class="d-flex align-items-center justify-content-center mb-0 mt-3 alert alert-info text-center">
        <em class="fa-solid fa-circle-info mr-2"></em>
        <span translate>No machinery groups found for searched term and filters.</span>
      </div>
    </div>
  </div>
</div>

<scitis-ngx-pagination [id]="paginateSettings.id"
                       paginationClass="col"
                       [itemsPerPage]="paginateSettings.itemsPerPage"
                       [itemsPerPageOptions]="itemsPerPageOptions"
                       (itemsPerPageChange)="onItemsPerPageChange($event)"
                       (pageNumberChange)="onLoadPageNumber($event)">
</scitis-ngx-pagination>
